import { PlusIcon } from "@heroicons/react/20/solid";
import { useEffect } from "react";
import { connect } from "react-redux";
import { Actions } from "../../../store/actions/employeeActions";
import NoItemsRow from "../../common/NoItemsRow";
import DownloadForms from "../DownloadForms";
import AttachmentOfEarningsModal from "./AttachmentOfEarningsModal";
import AttachmentOfEarningsRow from "./AttachmentOfEarningsRow";
import PaymentHistoryModal from "./PaymentHistoryModal";

const AttachmentOfEarnings = ({
  attachmentEarnings,
  openAttachmentsModal,
  agreement,
  getList,
  loading,
  name,
  namePlural,
  defaultType,
}) => {
	useEffect(() => {
		if (!loading) getList();
	}, []);

	return (
		<div className="px-8 pt-6">
			<AttachmentOfEarningsModal />
			<PaymentHistoryModal />
			<div className="col-xs-12 form-section">
				<div className="col-xs-6 section-header">
					<h1>{namePlural}</h1>
				</div>
				<div className="col-xs-6">
					<button
						className="btn btn-success pull-right"
						type="button"
						onClick={() => openAttachmentsModal(defaultType)}
						style={{ marginTop: 5, marginLeft: 10 }}
					>
						<PlusIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
						<div style={{ float: "left" }}>Add {name}</div>
					</button>
					<DownloadForms {...{ formType: "direct attachments full", agreementId: agreement }} />
				</div>
				<div className="clearfix" />
				{attachmentEarnings?.length > 0 ? (
					<div className="form-inner-section pr-0 pl-0">
						<div
							style={{
								display: "grid",
								gridGap: "1.5rem",
								grid: "1.5rem",
								gridTemplateColumns: "repeat(6, minmax(0, 1fr))",
								padding: "1rem",
								borderBottom: "solid rgb(244,244,244) 4px",
							}}
						>
							<div style={{ gridColumn: "span 1 / span 6", textAlign: "center", opacity: "0.75" }}>
								<h5>Reference</h5>
							</div>
							<div style={{ gridColumn: "span 1 / span 6", textAlign: "center", opacity: "0.75" }}>
								<h5>Type</h5>
							</div>
							<div style={{ gridColumn: "span 1 / span 6", textAlign: "center", opacity: "0.75" }}>
								<h5>Paid to Date</h5>
							</div>
							<div style={{ gridColumn: "span 1 / span 6", textAlign: "center", opacity: "0.75" }}>
								<h5>Remaining</h5>
							</div>
							<div style={{ gridColumn: "span 1 / span 6", textAlign: "center", opacity: "0.75" }}>
								<h5>Total Amount</h5>
							</div>
							<div style={{ gridColumn: "span 1 / span 6", textAlign: "center", opacity: "0.75" }}></div>
						</div>
						{attachmentEarnings?.map((attachment, index) => {
							const isLast = index + 1 == attachmentEarnings.length;
							return (
								<AttachmentOfEarningsRow
									attachment={attachment}
									isLast={isLast}
									key={attachment.id}
								/>
							);
						})}
					</div>
				) : (
					<table className="js-table-sections table table-hover">
						<NoItemsRow name={namePlural} />
					</table>
				)}
			</div>
		</div>
	);
};

const mapStateToProps = (state, ownProps) => {

	const aoeDetails = ownProps.details[ownProps.index]
	const items = state.employee?.attachmentEarnings?.items ?? []

	const attachmentEarnings = aoeDetails?.filter ? items?.filter(aoeDetails.filter) : items

	return {
		agreement: state.employee?.agreementInfo?.id,
		attachmentEarnings,
		loading: state.employee?.attachmentEarnings?.loading,
		currency: state.company?.settings?.currency,
		defaultType: aoeDetails?.defaultType,
		name: aoeDetails?.name ?? "Attachment of Earnings",
		namePlural: aoeDetails?.namePlural ?? "Attachments of Earnings",
	};
};

const mapDispatchToProps = (dispatch, ownProps) => ({
	openAttachmentsModal: (defaultType) => dispatch(Actions.toggleAttachmentEarningsModal({ open: true, defaultType })),
	getList: () => dispatch(Actions.getLongTermAdjustments()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AttachmentOfEarnings);
